module.exports = __webpack_public_path__ + "img/demo-photo01.4ee518f3.jpg";